import { Button, Text, Flex } from "@jsq/ds/core";
import { SubmitButton, FormTextarea, FormRadioGroup, FormRadioButton } from "@jsq/ds/forms";
import { Sizes } from "@jsq/ds/styles";
import { recipientsLabel, commentSection, buttonSection } from "./styles_vanilla.css";

type CancelRequestFormContentProps = {
  recipients: string[];
  onClose: () => void;
  loading?: boolean;
};

export const CancelRequestFormContent = ({
  recipients,
  onClose,
  loading,
}: CancelRequestFormContentProps) => {
  return (
    <Flex flexDirection="column" gap="20px">
      <Text variant="regular-md">
        The URL sent to recipients will be cancelled. Please provide a reason for the
        cancellation in the comment field below.
      </Text>

      <Flex flexDirection="column" gap="6px">
        <Text variant="regular-md" className={recipientsLabel}>
          Request recipients
        </Text>
        <Flex flexDirection="column" gap="6px">
          {recipients.map((recipient, index) => (
            <Text key={index} variant="regular-md">
              {recipient}
            </Text>
          ))}
        </Flex>
      </Flex>

      <FormTextarea
        name="comment"
        label="Comment"
        placeholder="This comment will be entered in the log of the associated change in circumstance case"
        isFullWidth
        className={commentSection}
      />

      <Flex flexDirection="column" gap={Sizes.SM}>
        <Text variant="strong-md">
          Do you want to retain the case associated with this request?
        </Text>
        <FormRadioGroup name="caseRetention" required>
          <FormRadioButton value="true">
            Yes, retain existing case and manage manually
          </FormRadioButton>
          <FormRadioButton value="false">No, close the existing case</FormRadioButton>
        </FormRadioGroup>
      </Flex>

      <Flex justifyContent="flex-end" gap="12px" className={buttonSection}>
        <Button variant="neutral" onClick={onClose}>
          Cancel
        </Button>
        <SubmitButton isLoading={loading} variant="danger">
          Cancel request
        </SubmitButton>
      </Flex>
    </Flex>
  );
};
